import { PetBreedDtoCategoryEnum } from 'woofwoof-api';

/**
 * Display label for a pet's type + breed, with fallbacks for guest bookings
 * where the owner skipped the breed or pet category.
 *
 *  - breed present                 → breed
 *  - no breed, category != Other   → "Rasa nieznana"
 *  - no breed, category Other/null → "Rodzaj i rasa nieznana"
 */
export function formatPetTypeAndBreed(
  petCategory?: PetBreedDtoCategoryEnum | string | null,
  breed?: string | null,
): string {
  const trimmedBreed = breed?.trim();
  if (trimmedBreed) return trimmedBreed;

  const isUnknownCategory =
    !petCategory || petCategory === PetBreedDtoCategoryEnum.Other;

  return isUnknownCategory ? 'Rodzaj i rasa nieznana' : 'Rasa nieznana';
}
